import { useQuery, gql } from '@apollo/client';

import { useAppDispatch } from '../../app/hooks';
import { setMerges } from './mergeSlice';
import { IUnit } from '../../types/unit';

export const useMergeQuery = (
  project: string,
  merges: string[],
  page: number,
  perPage: number,
  search: string = '',
  unit: IUnit | null = null
) => {
  const dispatch = useAppDispatch();

  let query: any = {
    project: project,
    mergeTypes: merges,
    search,
  };

  if (
    merges.some((merge: string) => merge.includes('Listing') || merge.includes('Management') || merge.includes('Tenancy')) &&
    merges.length === 1
  ) {
    query = {
      search,
      mergeTypes: merges,
    };
  }

  // mergeTypes is a custom filter arg that only applies when it's a top-level filter key (it
  // rewrites to rawQuery.type behind the scenes). Nested inside OR it's a no-op, since OR items
  // are only matched against real schema fields - so this branch uses the real `type` field
  // directly instead. It also deliberately omits `search`: the backend's `search` filter arg
  // unconditionally overwrites rawQuery.$or, which would clobber this OR entirely.
  if (unit) {
    query = {
      project: project,
      OR: [...merges.map((type: string) => ({ type })), { name: unit.suite }],
    };
  }

  return useQuery(MERGETEMPLATES, {
    fetchPolicy: 'network-only',
    variables: { filter: query, page: page + 1, perPage: perPage },
    onCompleted: (data) => {
      let mergeTemplates = data.mergeTemplatePagination.items;
      if (unit) {
        mergeTemplates = mergeTemplates.filter(
          (mergeTemplate: any) => mergeTemplate.name === unit.suite || mergeTemplate.type !== 'Floorplan'
        );
        dispatch(
          setMerges({
            count: data.mergeTemplatePagination.count,
            items: mergeTemplates,
          })
        );
      } else {
        dispatch(setMerges(data.mergeTemplatePagination));
      }
    },
    onError: (err) => {
      console.log(err, 'err');
    },
  });
};

const MERGETEMPLATES = gql`
  query mergeTemplatePagination(
    $filter: FilterFindManyMergeTemplateInput
    $page: Int!
    $perPage: Int!
    $sort: SortFindManyMergeTemplateInput
  ) {
    mergeTemplatePagination(filter: $filter, page: $page, perPage: $perPage, sort: $sort) {
      items {
        _id
        project {
          _id
        }
        name
        mergeFields {
          key
          index
          pageNumber
          x
          y
          fontSize
          format
          wrap
        }
        signFields {
          key
          index
          pageNumber
          x
          y
          name
          title
        }
        default
        totalPages
        type
        getUrl
        putUrl
      }
      count
    }
  }
`;
